import layout from '../layout'
export default function makeAudioCrudRoutes({
  contentType,
  components: { AudioListingContainer }
}) {

  return [
    {
      path: '/',
      component: layout,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: `/${contentType.name}/list/:categoryId`,
          component: AudioListingContainer,
          props: {
            contentType,
          }
        },
      ]
    },
  ];
}
